const initialState = {
  data: [],
  loading: false,
  error: false,
};

export function dayOfWeekAnalytics(state = initialState, action) {
  switch (action.type) {
    case "DAY_OF_WEEK_ANALYTICS_FETCH_DATA_SUCCESS":
      return { ...state, data: action.data, error: false };
    default:
      return state;
  }
}
